import React from 'react'

const Flexbox_Coding_Pratice_3 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 3</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_3
